/**
 * Posts API — typed migration of PostsAPI.js
 * CRUD for news/announcement posts (admin + teacher).
 *
 * Backend endpoints match the legacy API:
 *   GET    /posts        → Post[]
 *   POST   /posts        → Post
 *   PUT    /posts        → Post
 *   DELETE /posts/:id
 */
import apiClient from './client';
import type { Post } from './types';

const PostsAPI = {
  /** Fetch all visible posts */
  async getPosts(): Promise<Post[]> {
    const { data } = await apiClient.get<Post[]>('/posts');
    // Backend may return array directly (interceptor already unwraps { result })
    return Array.isArray(data) ? data : [];
  },

  /** Create a new post */
  async createPost(payload: Omit<Post, 'id' | 'timestamp'>): Promise<Post> {
    const { data } = await apiClient.post<Post>('/posts', payload);
    return data;
  },

  /** Update an existing post */
  async updatePost(payload: Partial<Post> & { id: string }): Promise<Post> {
    const { data } = await apiClient.put<Post>('/posts', payload);
    return data;
  },

  /** Delete a post by id */
  async deletePost(id: string): Promise<void> {
    await apiClient.delete(`/posts/${id}`, { data: { id } });
  },
};

export default PostsAPI;
